// studentBones.js
export const createStudentBones = (includeSpine = false, includeExtras = false) => {
    return {
        ...(includeExtras && {
            popup: null,
            blackboardText: null,
        }),

        ...(includeSpine && {
            spine01: null,
            spine02: null,
            spine01Original: 0,
            spine02Original: 0,
            isSitting: true,
        }),

        /* arms */
        rightArm: null,
        rightForearm: null,
        leftArm: null,
        leftForearm: null,

        /* hand end */
        rightHandEnd: null,
        leftHandEnd: null,

        /* legs */
        leftThigh: null,
        rightThigh: null,
        leftShin: null,
        rightShin: null,

        /* sitting data */
        sitThigh: 0,
        sitShin: 0,

        /* stand data */
        standLeftThigh: 0,
        standRightThigh: 0,
        standLeftShin: 0,
        standRightShin: 0,
    };
};